import React from 'react';
import { Box, Chip, Link, Tooltip, Typography } from '@mui/material';
import { contactFieldForValue, contactStatusPresentation } from '../../helper/leadContactStatus';

export default function LeadContactValues({ value, contacts = [], channel, run = null }) {
  const values = (Array.isArray(value) ? value : String(value || '').split(/,\s*/))
    .map((item) => String(item).trim()).filter(Boolean);
  return (
    <Box component="span" sx={{display: 'inline-flex', flexDirection: 'column', gap: 0.5, maxWidth: '100%', minWidth: 0}}>
      {values.map((text, index) => {
        const presentation = contactStatusPresentation(contactFieldForValue(contacts, channel, text, run));
        return (
          <Box component="span" key={`${text}-${index}`} sx={{display: 'inline-flex', alignItems: 'center', flexWrap: 'wrap', gap: 0.5, minWidth: 0}}>
            <Typography component="span" variant="inherit" sx={{overflowWrap: 'anywhere', minWidth: 0}}>
              {channel === 'linkedin' && /^https?:\/\//i.test(text)
                ? <Link href={text} target="_blank" rel="noreferrer" underline="hover">{text}</Link>
                : text}
            </Typography>
            {presentation && (
              <Tooltip title={presentation.tooltip}>
                <Chip size="small" label={presentation.label} color={presentation.color}
                  tabIndex={0}
                  aria-label={`${presentation.label}: ${presentation.tooltip}`}
                  sx={{height: 20, fontSize: 10, maxWidth: '100%'}} />
              </Tooltip>
            )}
          </Box>
        );
      })}
    </Box>
  );
}
